import { render, staticRenderFns } from "./SelfEmployedFormPage.vue?vue&type=template&id=82efb5f6&"
import script from "./SelfEmployedFormPage.vue?vue&type=script&lang=js&"
export * from "./SelfEmployedFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports